import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Environment } from '@environments/environment';
import { Observable } from 'rxjs';
// interface BaseAPiResponse<T> {
//   code: string;
//   message: 'success';
//   data: T;
// }

@Injectable({
  providedIn: 'root',
})
export class BaseApiService {
  private http = inject(HttpClient);

  basePost<reqT extends Record<string, string> | null, resT>(
    url: string,
    req: reqT
  ): Observable<resT> {
    const apiUrl = `${Environment.baseApiUrl}${url}`;
    const formData = new FormData();
    if (req) {
      const keys: string[] = Object.keys(req);
      const values: string[] = Object.values(req);
      keys.forEach((key, index) => {
        formData.append(key, values[index]);
      });
    }

    return this.http.post<resT>(apiUrl, formData, {
      observe: 'body',
      responseType: 'json',
    });
  }
}
